var ukStockists = [
  {
    "lat": 51.42019,
    "lng": -0.1349,
    "name": "Creative Soul",
    "url": "",
    "address": "Flat 1, Streatham, SW16 5PF, United Kingdom"
  },
  {
    "lat": 51.4816442,
    "lng": -3.177689,
    "name": "Cardiff Creative Shop",
    "url": "https://www.instagram.com/cardiffcreativeshop/?hl=en",
    "address": "40a Queen's Arcade, Cardiff, CF10 2BY, United Kingdom"
  },
  {
    "lat": 51.58125,
    "lng": -0.12615,
    "name": "Charcoal",
    "url": "",
    "address": "55 Park Road, London, N8 8SY, United Kingdom"
  },
  {
    "lat": 53.38738523,
    "lng": -2.9181667,
    "name": "A Slower Space",
    "url": "https://www.pennylanelifestylestore.co.uk/",
    "address": "38 Penny Lane, Liverpool, L18 1DG, United Kingdom"
  },
  {
    "lat": 52.6296603,
    "lng": 1.291690105,
    "name": "Elm.",
    "url": "https://www.elmshop.co.uk/",
    "address": "5-7 Lower Goat Lane, Norwich, NR2 1EL, United Kingdom"
  },
  {
    "lat": 53.0165005455,
    "lng": -1.7345394364,
    "name": "Sticky Fingers",
    "url": "",
    "address": "Sticky Fingers, Ashbourne, DE6 1AE, United Kingdom"
  },
  {
    "lat": 51.46612592,
    "lng": -2.561208054,
    "name": "BAM Store + Space",
    "url": "http://www.bambristol.co.uk/",
    "address": "BAM Store + Space, Bristol, BS5 6BX, United Kingdom"
  },
  {
    "lat": 55.0427179,
    "lng": -1.450544,
    "name": "Bellwoods Lifestyle Store",
    "url": "https://bellwoodslifestylestore.co.uk/",
    "address": "Bellwoods 94 Park View, Whitley Bay, NE26 3QL, United Kingdom"
  },
  {
    "lat": 52.05753,
    "lng": -2.71568,
    "name": "Isabella Harrison",
    "url": "http://www.lunagifts.co.uk/",
    "address": "Unit 1, 15 Maylord Street, Hereford, HR1 2DS, United Kingdom"
  },
  {
    "lat": 51.0804191,
    "lng": 1.1832658,
    "name": "Objectables",
    "url": "https://www.objectables.co.uk/about-us",
    "address": "35 The Old High Street, Folkestone, CT20 1RL, United Kingdom"
  },
  {
    "lat": 51.58549573,
    "lng": -0.0193868778,
    "name": "The Every Space",
    "url": "http://www.theeveryspace.com/",
    "address": "5 Central Parade, London, E17 4RT, United Kingdom"
  },
  {
    "lat": 53.73915255,
    "lng": -0.33484945,
    "name": "Form Shop & Studio",
    "url": "http://formshopandstudio.co.uk/",
    "address": "62 Humber Street, Kingston upon Hull, HU1 1TU, United Kingdom"
  },
  {
    "lat": 50.60882675,
    "lng": -1.9570868667,
    "name": "Yellow Gorse & Home Boheme",
    "url": "",
    "address": "2 Institute Road, Swanage, BH19 1BX, United Kingdom"
  },
  {
    "lat": 51.01935,
    "lng": -4.20659,
    "name": "Sunshine and Snow",
    "url": "",
    "address": "40 Mill Street, Bideford, EX39 2JW, United Kingdom"
  },
  {
    "lat": 51.63507,
    "lng": -0.10283,
    "name": "Agha Home",
    "url": "",
    "address": "1 Wades Hill, London, N21 1BD, United Kingdom"
  },
  {
    "lat": 52.343592,
    "lng": 1.5023734667,
    "name": "Focus Organic Ltd",
    "url": "",
    "address": "14 Thoroughfare, Halesworth, IP19 8AH, United Kingdom"
  },
  {
    "lat": 53.4836989357,
    "lng": -2.2347324071,
    "name": "Northern Flower",
    "url": "https://northernflower.com/",
    "address": "58 Tib Street, Manchester, M4 1LG, United Kingdom"
  },
  {
    "lat": 51.56811,
    "lng": -0.1102,
    "name": "Pretty Shiny Shop",
    "url": "",
    "address": "67 Stroud Green Road, London, N4 3EG, United Kingdom"
  },
  {
    "lat": 51.4728239875,
    "lng": -2.590962925,
    "name": "Reason Interiors Ltd",
    "url": "https://www.reasoninteriors.co.uk/",
    "address": "97 Gloucester Road, Bristol, BS7 8AT, United Kingdom"
  },
  {
    "lat": 51.52004861,
    "lng": -0.0754549125,
    "name": "Inspitalfields",
    "url": "https://www.inspitalfields.co.uk/",
    "address": "13a Lamb Street, London, E1 6EA, United Kingdom"
  },
  {
    "lat": 50.85683785,
    "lng": 0.591053075,
    "name": "Reste",
    "url": "http://www.reste.co.uk/",
    "address": "Reste, Hastings, TN34 3EN, United Kingdom"
  },
  {
    "lat": 51.53655321,
    "lng": -0.0615878826,
    "name": "She's Lost Control - Broadway Market",
    "url": "https://sheslostcontrol.co.uk/",
    "address": "74 Broadway Market, London, E8 4QJ, United Kingdom"
  },
  {
    "lat": 51.108866,
    "lng": -4.162881267,
    "name": "Wanderlust Life",
    "url": "https://www.hugedomains.com/domain_profile.cfm?d=wanderlustlife.com",
    "address": "14 Caen Street, Braunton, EX33 1AA, United Kingdom"
  },
  {
    "lat": 51.108866,
    "lng": -4.162881267,
    "name": "Wanderlust Life",
    "url": "https://www.hugedomains.com/domain_profile.cfm?d=wanderlustlife.com",
    "address": "14 Caen Street, Braunton, EX33 1AA, United Kingdom"
  },
  {
    "lat": 51.108866,
    "lng": -4.162881267,
    "name": "Wanderlust Life",
    "url": "http://wanderlustlife.co.uk/",
    "address": "14 Caen Street, Braunton, EX33 1AA, United Kingdom"
  },
  {
    "lat": 51.108866,
    "lng": -4.162881267,
    "name": "Wanderlust Life",
    "url": "http://wanderlustlife.co.uk/",
    "address": "14 Caen Street, Braunton, EX33 1AA, United Kingdom"
  },
  {
    "lat": 51.52599863,
    "lng": -0.1091461333,
    "name": "Space EC1",
    "url": "https://www.ifounditinspace.co.uk/",
    "address": "25 Exmouth Market, London, EC1R 4QL, United Kingdom"
  },
  {
    "lat": 51.45280208,
    "lng": -0.1019261,
    "name": "Jo's House",
    "url": "https://joshouse.co.uk/",
    "address": "299 Railton Road, London, SE24 0JN, United Kingdom"
  },
  {
    "lat": 51.56611095,
    "lng": 0.00199705,
    "name": "Jo & Kesi",
    "url": "https://en-gb.facebook.com/joandkesi/",
    "address": "2 RICHMOND ROAD, Leytonstone, E11 4BA, United Kingdom"
  },
  {
    "lat": 51.1014399,
    "lng": -0.23172,
    "name": "ADEL DE LUNE",
    "url": "",
    "address": "10 Somerset Road, Horsham, RH12 0DP, United Kingdom"
  },
  {
    "lat": 51.4532705258,
    "lng": -0.0005398065,
    "name": "You Don't Bring Me Flowers,",
    "url": "",
    "address": "15 Staplehurst Road, London, SE13 5ND, United Kingdom"
  },
  {
    "lat": 50.4055029,
    "lng": -5.0622252,
    "name": "Plastic Freedom",
    "url": "https://plasticfreedom.co.uk/",
    "address": "Plastic freedom, Newquay, TR7 2SX, United Kingdom"
  },
  {
    "lat": 51.46910177,
    "lng": -2.614369946,
    "name": "Paper Gangsta",
    "url": "https://maps.google.com/?cid=7542897923419221026",
    "address": "146 Whiteladies Road, Bristol, BS8 2RS, United Kingdom"
  },
  {
    "lat": 53.2330174467,
    "lng": -0.5386205,
    "name": "'Santa Maria'",
    "url": "",
    "address": "13 Steep Hill, Lincoln, LN2 1LT, United Kingdom"
  },
  {
    "lat": 50.18567081,
    "lng": -5.421342029,
    "name": "Lucy Kemp Jewellery",
    "url": "http://www.lucykempjewellery.co.uk/",
    "address": "Unit 7 Treglisson Rural Wshops, Hayle, TR27 5JT, United Kingdom"
  },
  {
    "lat": 52.95147979,
    "lng": -1.145801846,
    "name": "Nottingham Contemporary",
    "url": "http://www.nottinghamcontemporary.org/",
    "address": "Nottingham Contemporary, Nottingham, NG1 2GB, United Kingdom"
  },
  {
    "lat": 51.23095,
    "lng": -2.32295,
    "name": "Seed",
    "url": "http://www.designsbyseed.co.uk/",
    "address": "3 Catherine Hill, Frome, BA11 1BY, United Kingdom"
  },
  {
    "lat": 51.9479315,
    "lng": -0.2795144,
    "name": "Treat Yo' Self Gifts Ltd.",
    "url": "https://www.instagram.com/treatyoselfgifts/?hl=en",
    "address": "3 Arcade Walk, Hitchin, SG5 1EE, Hitchin, SG5 1EE, United Kingdom"
  },
  {
    "lat": 50.7121948,
    "lng": -2.4657149,
    "name": "YARD",
    "url": "",
    "address": "171 Bridport Road, Dorchester, DT1 3AH, United Kingdom"
  },
  {
    "lat": 51.5488801,
    "lng": -0.0544447,
    "name": "Wave",
    "url": "http://www.weareveganeverything.com/",
    "address": "11 Dispensary Lane, London, E8 1FT, United Kingdom"
  },
  {
    "lat": 50.2842417,
    "lng": -3.777557167,
    "name": "Wanderlust Wares",
    "url": "http://www.wanderlustwares.co.uk/",
    "address": "46 Fore Street, Kingsbridge, TQ7 1NY, United Kingdom"
  },
  {
    "lat": 54.97747,
    "lng": -1.5964799,
    "name": "Yoga X Life Newcastle | YogaTherapies",
    "url": "",
    "address": "Units 1-3 Bryson court, Newcastle upon tyne , NE2 1DW, United Kingdom"
  },
  {
    "lat": 51.38819,
    "lng": 1.4006,
    "name": "Considered.Store",
    "url": "",
    "address": "66 Norfolk Road, Margate, CT9 2HZ, United Kingdom"
  },
  {
    "lat": 51.5408195,
    "lng": -0.1029543889,
    "name": "Superette - Upper Street",
    "url": "https://superettestore.com/",
    "address": "Superette , London, N6 6AG, United Kingdom"
  },
  {
    "lat": 50.12999,
    "lng": -5.17849,
    "name": "Slice of Cornwall",
    "url": "http://sliceofcornwall.com/",
    "address": "Slice of Cornwall, Trewardreva Mill, Falmouth, TR11 5QD, United Kingdom"
  },
  {
    "lat": 50.38098337,
    "lng": -4.133227027,
    "name": "Pickle Deli and Market",
    "url": "https://www.pickledeli.co.uk/",
    "address": "21 Mutley Plain, Plymouth, PL4 6JG, United Kingdom"
  },
  {
    "lat": 50.72069425,
    "lng": -3.535179735,
    "name": "Helen of Troy",
    "url": "http://www.helenoftroyboutique.com/",
    "address": "141 Fore St, Exeter, EX4 3AN, United Kingdom"
  },
  {
    "lat": 53.4021501667,
    "lng": -2.9862532667,
    "name": "WANDER",
    "url": "",
    "address": "Pocket Cafe Bar, Liverpool, L1 3HJ, United Kingdom"
  },
  {
    "lat": 51.4174327,
    "lng": -0.08068295,
    "name": "Elkins",
    "url": "https://instagram.com/elkinsshop",
    "address": "407 GREAT WESTERN ROAD, GLASGOW, G4 9JA, United Kingdom"
  },
  {
    "lat": 52.303970675,
    "lng": -0.707776425,
    "name": "Evie Bevie Ltd",
    "url": "",
    "address": "4 Lilac Court, Wellingborough, NN8 3GN, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.80819435,
    "lng": 0.1565914,
    "name": "Pepper You",
    "url": "https://pepperyou.co.uk/",
    "address": "5 Waterloo Square, Polegate, BN26 5UD, United Kingdom"
  },
  {
    "lat": 50.11808,
    "lng": -5.53657,
    "name": "&Living",
    "url": "https://andliving.co.uk/",
    "address": "66 Chapel Street, Penzance, TR18 4AD, United Kingdom"
  },
  {
    "lat": 50.5462655,
    "lng": -3.4941584,
    "name": "ROAM by The Drifting Bear Co",
    "url": "",
    "address": "ROAM, 7 The Triangle, Teignmouth, TQ14 8AU, United Kingdom"
  },
  {
    "lat": 55.9482409405,
    "lng": -3.253865368,
    "name": "Cloud 9  Edinburgh",
    "url": "http://www.cloud9edinburgh.co.uk/",
    "address": "40 Easter Rd, Edinburgh, EH7 5RG, United Kingdom"
  },
  {
    "lat": 51.56202481,
    "lng": -0.0795925727,
    "name": "Bless",
    "url": "https://blessstories.com/pages/our-shop",
    "address": "111 Stoke Newington Church Street, London, N16 0UD, United Kingdom"
  },
  {
    "lat": 51.44015791,
    "lng": -2.609664955,
    "name": "Devaki Jones",
    "url": "http://www.plant.studio/",
    "address": "175 North St., Bristol, BS3 1JQ, United Kingdom"
  },
  {
    "lat": 50.910743,
    "lng": -0.0978662708,
    "name": "Claire Robilliard",
    "url": "",
    "address": "2 Glebe Cottages, Lewes Road, Westmeston, Hassocks, BN6 8RH, United Kingdom"
  },
  {
    "lat": 51.2743202138,
    "lng": 1.3396090172,
    "name": "Mango House",
    "url": "",
    "address": "9 New Street, Sandwich, CT13 9AB, United Kingdom"
  },
  {
    "lat": 50.63659,
    "lng": -4.36031,
    "name": "The Byre",
    "url": "https://thebyre.co.uk/",
    "address": "The Byre , Launceston , PL15 8AA, United Kingdom"
  },
  {
    "lat": 51.43992,
    "lng": -0.12552,
    "name": "Cornercopia - Homestore & Plant Store",
    "url": "",
    "address": "63 streatham Hill, London , SW2 4TX, United Kingdom"
  },
  {
    "lat": 53.3793232,
    "lng": -1.47701563,
    "name": "CollardManson",
    "url": "",
    "address": "123-125 Devonshire Street, Sheffield, S3 7SB, United Kingdom"
  },
  {
    "lat": 50.7334597,
    "lng": -1.8191744,
    "name": "Inipi Beauty Boutique",
    "url": "",
    "address": "1078 Christchurch Road, Bournemouth, BH7 6DS, United Kingdom"
  },
  {
    "lat": 50.8310133,
    "lng": -0.1884731667,
    "name": "Village BN3",
    "url": "http://www.villagebn3.com/",
    "address": "4 Richardson road, Hove, BN3 5RB, United Kingdom"
  },
  {
    "lat": 53.4379,
    "lng": -3.04828,
    "name": "SUP",
    "url": "http://www.wearesupshop.com/",
    "address": "6 Atherton Street, Wallasey, CH45 2NY, United Kingdom"
  },
  {
    "lat": 53.82355005,
    "lng": -1.579645833,
    "name": "Bowery Visual Arts",
    "url": "",
    "address": "54 Otley Road, Leeds, LS6 2AL, United Kingdom"
  },
  {
    "lat": 50.3520172,
    "lng": -3.5798679,
    "name": "Leocadia",
    "url": "http://www.leocadia.uk/",
    "address": "Leocadia, 4 Union Street, Dartmouth, TQ6 9DP, United Kingdom"
  },
  {
    "lat": 55.8643411,
    "lng": -4.2839867,
    "name": "Curated & Gifted",
    "url": "",
    "address": "The Hidden Lane, Unit 25 (Pale Blue Building), Glasgow, G3 8ND, United Kingdom"
  },
  {
    "lat": 51.51751,
    "lng": 0.00045,
    "name": "Crisis Uk",
    "url": "",
    "address": "Unit 4 Segro park, london, E16 4ES, United Kingdom"
  },
  {
    "lat": 51.46290146,
    "lng": -2.596036695,
    "name": "Other Worlds are Possible",
    "url": "https://www.facebook.com/Otherworldsarepossible/",
    "address": "6 Saint Matthew's Road, Bristol, BS6 5TS, United Kingdom"
  },
  {
    "lat": 55.87749391,
    "lng": -4.28925755,
    "name": "Penny Black",
    "url": "https://www.penny-black.co.uk/",
    "address": "Penny Black Glasgow Ltd, Glasgow, G12 8QX, United Kingdom"
  },
  {
    "lat": 50.26265567,
    "lng": -5.049149086,
    "name": "Inhabit",
    "url": "",
    "address": "Inhabit, Truro, TR1 2LH, United Kingdom"
  },
  {
    "lat": 50.71671,
    "lng": -1.95112,
    "name": "Edwards",
    "url": "",
    "address": "83 Wedgwood Drive, Poole, BH14 8EU, United Kingdom"
  },
  {
    "lat": 55.9446981273,
    "lng": -3.1853506545,
    "name": "Lighthouse Bookshop",
    "url": "https://lighthousebookshop.com/",
    "address": "43-45 West Nicolson Street, Edinburgh, EH8 9DB, United Kingdom"
  },
  {
    "lat": 55.9483673,
    "lng": -3.2524737,
    "name": "Bold and Gold Piercing Art",
    "url": "",
    "address": "1B Easter Road, Edinburgh, EH7 5PH, United Kingdom"
  },
  {
    "lat": 54.4653,
    "lng": -3.5277,
    "name": "Benny and Mollie",
    "url": "",
    "address": "6 Chapel Terrace Thornhill Egremont CA22 2RJ, Egremont, Thornhill, CA22 2RJ, United Kingdom"
  },
  {
    "lat": 51.5873771429,
    "lng": -0.0208816714,
    "name": "Poeme London",
    "url": "",
    "address": "116 Hoe Street, London, E17 4QR, United Kingdom"
  },
  {
    "lat": 55.7696026,
    "lng": -2.0044957,
    "name": "Puddles",
    "url": "http://puddlesboutique.co.uk/",
    "address": "18 West Street, Berwick-upon-Tweed, TD15 1AS, United Kingdom"
  },
  {
    "lat": 51.0624777,
    "lng": 0.3384835,
    "name": "@ One",
    "url": "http://at-one.co.uk/",
    "address": "@ One, 16 High Street, Tunbridge Wells, TN1 1UX, Tunbridge Wells, TN1 1UX, United Kingdom"
  },
  {
    "lat": 52.74009,
    "lng": -2.73434,
    "name": "Mistilley",
    "url": "http://www.mistilley.com/",
    "address": "119 Harlescott Lane, Shrewsbury, SY1 3AR, United Kingdom"
  },
  {
    "lat": 51.04191,
    "lng": -3.31177,
    "name": "Ella Lawrence",
    "url": "",
    "address": "17 High Street, Wiveliscombe , TA4 2JX, United Kingdom"
  },
  {
    "lat": 51.06297,
    "lng": -1.3116,
    "name": "Projects Store & Kitchen",
    "url": "",
    "address": "6 MIDDLE BROOK STREET, Winchester, SO23 8BQ, United Kingdom"
  },
  {
    "lat": 50.8424147444,
    "lng": -0.1348740944,
    "name": "Store Next Door",
    "url": "",
    "address": "253d Ditchling Road Brighton BN1 6JD, brighton, BN1 6JD, United Kingdom"
  },
  {
    "lat": 51.5383458462,
    "lng": -0.0438631615,
    "name": "Sublime",
    "url": "",
    "address": "225 Victoria Park Road, London, E9 7HD, United Kingdom"
  },
  {
    "lat": 51.5028031375,
    "lng": -0.31691432,
    "name": "Mooch Ealing Ltd",
    "url": "",
    "address": "90 Northfield Avenue, London, W13 9RT, United Kingdom"
  },
  {
    "lat": 55.863563,
    "lng": -4.2554094,
    "name": "MAIA GIFTS",
    "url": "https://maiagifts.co.uk/",
    "address": "21 Bath Street, Glasgow, G2 1HW, United Kingdom"
  },
  {
    "lat": 51.56421,
    "lng": -0.00679,
    "name": "Edie Rose",
    "url": "https://edierose.co.uk/",
    "address": "228 Francis Road, London, E10 6NQ, United Kingdom"
  },
  {
    "lat": 53.3997111,
    "lng": -2.0527235,
    "name": "The Little Green Flower Company",
    "url": "",
    "address": "1A Longhurst Lane, Stockport, SK6 5AE, United Kingdom"
  },
  {
    "lat": 50.43127,
    "lng": -3.68659,
    "name": "Chi Chi’s",
    "url": "https://www.chichistotnes.com/",
    "address": "Ash Court, Orchid Way, Torquay Devon, TQ2 8GX, United Kingdom"
  },
  {
    "lat": 51.86742453,
    "lng": -0.5862652333,
    "name": "Heirloom Cafe",
    "url": "https://www.heirloom.cafe/",
    "address": "14 High Street, Edlesborough, LU6 2HS, United Kingdom"
  },
  {
    "lat": 54.95488,
    "lng": -1.39997,
    "name": "Nomad Flower Den",
    "url": "http://www.nomad-studios.uk/",
    "address": "9 Front Street, Sunderland, SR6 7QE, United Kingdom"
  },
  {
    "lat": 50.2790899,
    "lng": -5.22169,
    "name": "Tris Surf Shop",
    "url": "http://trissurfshop.com/",
    "address": "Heron Hall, Mount Hawke, TR4 8DL, United Kingdom"
  },
  {
    "lat": 52.95535902,
    "lng": 0.85240288,
    "name": "Bringing the outside in",
    "url": "http://www.bringingtheoutsidein.co.uk/",
    "address": "18 Staithe street, Wells-Next-The-Sea, NR23 1AF, United Kingdom"
  },
  {
    "lat": 50.8381397,
    "lng": -0.1517498,
    "name": "Posh Totty Designs",
    "url": "https://www.poshtottydesigns.com/",
    "address": "33 New Road, Brighton, BN1 1UG, United Kingdom"
  },
  {
    "lat": 55.9511629667,
    "lng": -3.1900079167,
    "name": "Fruitmarket",
    "url": "",
    "address": "45 Market Street, Edinburgh, EH1 1DF, United Kingdom"
  },
  {
    "lat": 55.92740784,
    "lng": -3.209141577,
    "name": "Hestie",
    "url": "https://www.hestie.co.uk/",
    "address": "245 Morningside Road, Edinburgh, EH10 4QU, United Kingdom"
  },
  {
    "lat": 51.2809809,
    "lng": 1.2797078,
    "name": "Juliet's Farm Shop and Cafe",
    "url": "",
    "address": "Juliet's Farm Shop and Cafe, , Ash Canterbury, CT3 2BA, United Kingdom"
  },
  {
    "lat": 51.3598449667,
    "lng": 1.4363635833,
    "name": "Kope + Loko",
    "url": "",
    "address": "136 High Street, Broadstairs, CT10 1JB, United Kingdom"
  },
  {
    "lat": 51.49218,
    "lng": -0.1579313,
    "name": "VITA Health & Fitness",
    "url": "",
    "address": "31 Sloane Square, London, SW1W 8AQ, United Kingdom"
  },
  {
    "lat": 52.6169579,
    "lng": -1.1007191,
    "name": "In-haus",
    "url": "",
    "address": "8 Allandale Road, Leicester, LE2 2DA, United Kingdom"
  },
  {
    "lat": 51.43894715,
    "lng": -2.61194675,
    "name": "Something Elsie",
    "url": "",
    "address": "23 luckwell road, Bristol, BS3 3EW, United Kingdom"
  },
  {
    "lat": 51.51276567,
    "lng": -0.0937468667,
    "name": "Stem and stem",
    "url": "",
    "address": "12 Bow Lane, London, EC4M 9AL, United Kingdom"
  },
  {
    "lat": 54.582697,
    "lng": -5.945896,
    "name": "Reids Florists",
    "url": "",
    "address": "Reids Florist, BELFAST, BT9 6AJ, United Kingdom"
  },
  {
    "lat": 51.55157,
    "lng": -0.05552,
    "name": "cai & jo",
    "url": "https://caiandjo.com/",
    "address": "Flat 7, London, E5 8HY, United Kingdom"
  },
  {
    "lat": 51.5132906,
    "lng": -0.30189525,
    "name": "Greenka ltd",
    "url": "https://greenka.uk/",
    "address": "8 Oak Road, London, W5 3SS, United Kingdom"
  },
  {
    "lat": 51.4643083,
    "lng": -2.610151583,
    "name": "Inca Gifts",
    "url": "https://www.facebook.com/pages/category/Shopping---retail/Inca-Gifts-303367540060972/",
    "address": "Clifton Down Shopping Centre, Bristol, BS8 2NN, United Kingdom"
  },
  {
    "lat": 52.8904156,
    "lng": -4.057089,
    "name": "pwts",
    "url": "",
    "address": "Plas Uchaf Farm, Talsarnau, LL47 6YA, United Kingdom"
  },
  {
    "lat": 51.389363,
    "lng": 1.3831841667,
    "name": "Store collective",
    "url": "",
    "address": "26 hawley street, Margate, CT9 1QA, United Kingdom"
  },
  {
    "lat": 51.4773296143,
    "lng": -0.2862640857,
    "name": "Mia Wood",
    "url": "",
    "address": "9 Station Parade, Richmond, TW9 3PS, United Kingdom"
  }
]